{
  "admission": "प्रवेश",
  "transfer": "स्थानांतरण",
  "visit": "भेंट",
  "type": "भेंट प्रकार",
  "status": "स्थिति",
  "location": "स्थान",
  "attendingPhysician": "उपस्थित चिकित्सक",
  "admitDate": "प्रवेश तिथि",
  "dischargeDate": "छुट्टी तिथि",
  "chiefComplaint": "मुख्य शिकायत",
  "diagnosis": "निदान",
  "class": {
    "label": "श्रेणी",
    "values": {
      "emergency": "आपातकालीन",
      "inpatient": "अंतःरोगी",
      "outpatient": "बहिःरोगी",
      "observation": "अवलोकन",
      "ambulatory": "डे-केयर",
      "homeHealth": "गृह चिकित्सा",
      "virtual": "टेलीमेडिसिन"
    }
  },
  "statusValues": {
    "label": "स्थिति",
    "values": {
      "pending": "लंबित",
      "arrived": "पहुँच गए",
      "active": "सक्रिय",
      "completed": "पूर्ण",
      "cancelled": "रद्द"
    }
  },
  "admissionSource": {
    "label": "प्रवेश स्रोत",
    "none": "—",
    "values": {
      "emergency": "आपातकालीन विभाग",
      "clinicReferral": "क्लिनिक रेफरल",
      "physicianReferral": "चिकित्सक रेफरल",
      "transfer": "अन्य संस्थान से स्थानांतरण",
      "self": "स्व-रेफरल / वॉक-इन",
      "courtLaw": "न्यायालय / कानून प्रवर्तन"
    }
  },
  "admissionType": {
    "label": "प्रवेश प्रकार",
    "none": "—",
    "values": {
      "elective": "नियोजित",
      "emergency": "आपातकालीन",
      "urgent": "अत्यावश्यक",
      "newborn": "नवजात",
      "trauma": "आघात"
    }
  },
  "acuity": {
    "label": "गंभीरता स्तर",
    "none": "—",
    "values": {
      "1": "1 — पुनरुज्जीवन",
      "2": "2 — अति गंभीर",
      "3": "3 — अत्यावश्यक",
      "4": "4 — कम अत्यावश्यक",
      "5": "5 — गैर-अत्यावश्यक"
    },
    "shortValues": {
      "1": "पुनरुज्जीवन",
      "2": "अति गंभीर",
      "3": "अत्यावश्यक",
      "4": "कम अत्यावश्यक",
      "5": "गैर-अत्यावश्यक"
    },
    "esiBadge": "ESI {{level}} - {{label}}"
  },
  "form": {
    "title": "नई भेंट",
    "subtitle": "इस रोगी के लिए नई भेंट / प्रवेश प्रारंभ करें।",
    "sections": {
      "visit": "भेंट विवरण",
      "reasonForVisit": "भेंट का कारण",
      "admission": "प्रवेश विवरण"
    },
    "fields": {
      "facility": "संस्थान",
      "encounterClass": "भेंट श्रेणी",
      "encounterType": "भेंट प्रकार",
      "department": "विभाग",
      "attendingProvider": "उपस्थित चिकित्सक",
      "acuity": "गंभीरता स्तर",
      "visitReason": "भेंट का कारण",
      "chiefComplaint": "मुख्य शिकायत",
      "admissionSource": "प्रवेश स्रोत",
      "admissionType": "प्रवेश प्रकार"
    },
    "placeholders": {
      "selectFacility": "संस्थान चुनें",
      "none": "—",
      "encounterType": "उदा. वार्षिक स्वास्थ्य जाँच, ER भेंट",
      "visitReason": "संक्षिप्त लेबल, उदा. फॉलो-अप, वार्षिक जाँच",
      "chiefComplaint": "रोगी द्वारा स्वयं के शब्दों में बताया गया कारण"
    },
    "providerFallback": "चिकित्सक #{{id}}",
    "submit": "भेंट बनाएँ",
    "validation": {
      "facilityRequired": "संस्थान आवश्यक है",
      "encounterClassRequired": "भेंट श्रेणी आवश्यक है"
    },
    "createdSuccess": "भेंट बनाई गई",
    "createError": "भेंट बनाने में विफल"
  },
  "detail": {
    "loading": "भेंट लोड हो रही है...",
    "notFound": "भेंट नहीं मिली",
    "loadError": "एनकाउंटर लोड करने में विफल",
    "retry": "पुनः प्रयास",
    "returnToDashboard": "डैशबोर्ड पर वापस जाएँ",
    "header": {
      "title": "भेंट {{number}}",
      "facilityLabel": "संस्थान #{{id}}",
      "departmentLabel": "विभाग #{{id}}",
      "locationLabel": "स्थान #{{id}}",
      "admittedLabel": "प्रवेश: {{datetime}}"
    },
    "actions": {
      "transfer": "स्थानांतरण",
      "discharge": "छुट्टी"
    },
    "tabs": {
      "overview": "सारांश",
      "orders": "आदेश",
      "results": "परिणाम",
      "medications": "औषधियाँ",
      "notes": "नोट्स",
      "billing": "बिलिंग"
    },
    "overview": {
      "chiefComplaint": "मुख्य शिकायत",
      "visitReason": "भेंट का कारण",
      "attendingProvider": "उपस्थित चिकित्सक",
      "acuityLevel": "गंभीरता स्तर",
      "providerFallback": "चिकित्सक #{{id}}",
      "empty": "--"
    },
    "timeline": {
      "title": "घटना समय रेखा",
      "empty": "कोई घटना दर्ज नहीं",
      "admittedTitle": "प्रवेश",
      "admittedDescription": "{{class}} - {{chiefComplaint}}",
      "noChiefComplaint": "कोई मुख्य शिकायत नहीं",
      "orderTitle": "आदेश: {{name}}",
      "orderDescription": "{{type}} - {{priority}} - {{status}}",
      "resultTitle": "परिणाम: {{type}}"
    },
    "orders": {
      "title": "आदेश",
      "newOrder": "+ नया आदेश",
      "empty": "इस भेंट के लिए कोई आदेश नहीं",
      "metaLine": "{{number}} | {{type}} | प्राथमिकता: {{priority}}"
    },
    "results": {
      "title": "परिणाम",
      "empty": "इस भेंट के लिए कोई परिणाम नहीं",
      "criticalBadge": "गंभीर",
      "viewLink": "देखें",
      "metaLine": "{{number}} | {{status}}"
    },
    "medications": {
      "title": "औषधियाँ",
      "newMedication": "+ नई औषधि",
      "empty": "इस भेंट के लिए कोई औषधि नहीं",
      "prnBadge": "PRN",
      "prnWithIndication": "PRN: {{indication}}"
    },
    "notes": {
      "comingSoon": "क्लिनिकल नोट्स मॉड्यूल जल्द ही आ रहा है",
      "goToClinicalNotes": "क्लिनिकल नोट्स पर जाएँ"
    },
    "billing": {
      "comingSoon": "बिलिंग मॉड्यूल जल्द ही आ रहा है"
    }
  },
  "census": {
    "title": "बेड बोर्ड / जनगणना",
    "subtitle": "वास्तविक समय बेड उपयोग और रोगी जनगणना",
    "refresh": "रिफ्रेश",
    "facilityName": "सिंगापुर जनरल अस्पताल",
    "capacitySummary": "उपयोग में {{occupied}} / कुल {{total}} बेड",
    "occupancyLabel": "{{percent}}% उपयोग दर",
    "stats": {
      "totalCapacity": "कुल क्षमता",
      "occupied": "उपयोग में",
      "available": "उपलब्ध",
      "pendingDischarge": "छुट्टी लंबित"
    },
    "unitFilter": {
      "all": "सभी इकाइयाँ",
      "er": "ER",
      "icu": "ICU",
      "medsurg": "मेडिकल/सर्जिकल",
      "obs": "अवलोकन",
      "peds": "बाल चिकित्सा",
      "maternity": "प्रसूति"
    },
    "roleView": {
      "nurse": "नर्स दृश्य",
      "physician": "चिकित्सक दृश्य",
      "bedManager": "बेड प्रबंधक दृश्य"
    },
    "viewMode": {
      "grid": "ग्रिड दृश्य",
      "table": "तालिका दृश्य"
    },
    "loading": "जनगणना डेटा लोड हो रहा है...",
    "columns": {
      "patient": "रोगी",
      "mrn": "MRN",
      "admitDate": "प्रवेश तिथि",
      "status": "स्थिति",
      "acuity": "गंभीरता",
      "isolation": "पृथक्करण",
      "fallRisk": "गिरने का जोखिम",
      "codeStatus": "कोड स्थिति",
      "chiefComplaint": "मुख्य शिकायत",
      "attending": "उपस्थित",
      "los": "LOS",
      "locationBed": "स्थान / बेड",
      "transferStatus": "स्थानांतरण स्थिति",
      "expectedDischarge": "अपेक्षित छुट्टी",
      "actions": "कार्य"
    },
    "values": {
      "unknownPatient": "अज्ञात",
      "none": "कोई नहीं",
      "notAvailable": "N/A",
      "pending": "लंबित",
      "empty": "--",
      "providerFallback": "चिकित्सक #{{id}}",
      "locationLabel": "स्थान #{{id}}",
      "losDays": "{{days}} दिन"
    },
    "codeStatusTooltip": "कोड स्थिति रोगी चार्ट पर उपलब्ध है",
    "actionsMenu": {
      "label": "कार्य",
      "viewChart": "चार्ट देखें",
      "transfer": "स्थानांतरण",
      "assignAttending": "उपस्थित चिकित्सक नियुक्त करें",
      "discharge": "छुट्टी"
    },
    "empty": "कोई सक्रिय भेंट नहीं मिली",
    "department": {
      "filteredTo": "केवल {{name}} दिखाया जा रहा है",
      "idLabel": "विभाग {{id}}",
      "showAll": "सभी विभाग दिखाएँ"
    },
    "facility": {
      "label": "सुविधा",
      "allFacilities": "सभी सुविधाएँ",
      "idLabel": "सुविधा {{id}}"
    }
  },
  "discharge": {
    "label": "छुट्टी",
    "title": "डिस्चार्ज वर्कफ़्लो",
    "encounterLabel": "भेंट {{number}}",
    "printButton": "डिस्चार्ज प्रिंट करें",
    "loading": "भेंट लोड हो रही है...",
    "notFound": "भेंट नहीं मिली",
    "returnToDashboard": "डैशबोर्ड पर वापस जाएँ",
    "notActive": "यह भेंट सक्रिय नहीं है (स्थिति: {{status}})",
    "backToEncounter": "भेंट पर वापस जाएँ",
    "progress": {
      "requiredMissingTooltip": "अनिवार्य फ़ील्ड अधूरे हैं",
      "tasksRemainingTooltip": "कुछ कार्य शेष हैं"
    },
    "steps": {
      "summary": "डिस्चार्ज सारांश",
      "medications": "दवाएँ",
      "followup": "फ़ॉलो-अप",
      "instructions": "निर्देश",
      "nursing": "नर्सिंग कार्य",
      "signoff": "अटेंडिंग चिकित्सक के हस्ताक्षर",
      "review": "समीक्षा और पुष्टि"
    },
    "summary": {
      "title": "डिस्चार्ज सारांश",
      "diagnosisLabel": "डिस्चार्ज निदान *",
      "diagnosisPlaceholder": "डिस्चार्ज निदान दर्ज करें...",
      "diagnosisCodeLabel": "डिस्चार्ज निदान कोड (ICD-10)",
      "diagnosisCodePlaceholder": "ICD-10 कोड खोजें...",
      "proceduresLabel": "की गई प्रक्रियाएँ",
      "proceduresPlaceholder": "इस भेंट के दौरान की गई प्रक्रियाओं की सूची दें...",
      "conditionLabel": "डिस्चार्ज पर स्थिति *"
    },
    "condition": {
      "values": {
        "stable": "स्थिर",
        "improved": "बेहतर",
        "unchanged": "अपरिवर्तित",
        "worsened": "बिगड़ी",
        "critical": "गंभीर"
      }
    },
    "medications": {
      "title": "डिस्चार्ज दवाएँ",
      "instructions": "प्रत्येक दवा की समीक्षा करें और डिस्चार्ज पर जारी रखने, बंद करने या बदलने का चयन करें।",
      "actions": {
        "continue": "जारी रखें",
        "stop": "बंद करें",
        "modify": "बदलें"
      },
      "modifiedPlaceholder": "संशोधित निर्देश दर्ज करें...",
      "empty": "इस भेंट के लिए कोई सक्रिय दवा नहीं"
    },
    "medAction": {
      "values": {
        "continue": "जारी रखें",
        "stop": "बंद करें",
        "modify": "बदलें"
      }
    },
    "followup": {
      "title": "फ़ॉलो-अप अपॉइंटमेंट",
      "providerLabel": "फ़ॉलो-अप चिकित्सक",
      "providerPlaceholder": "चिकित्सक का नाम या विशेषज्ञता...",
      "dateLabel": "फ़ॉलो-अप दिनांक",
      "notesLabel": "अतिरिक्त नोट्स",
      "notesPlaceholder": "फ़ॉलो-अप के लिए अतिरिक्त नोट्स..."
    },
    "instructions": {
      "title": "रोगी के लिए निर्देश",
      "generalLabel": "सामान्य निर्देश",
      "generalPlaceholder": "रोगी के लिए सामान्य डिस्चार्ज निर्देश...",
      "dietaryLabel": "आहार निर्देश",
      "dietaryPlaceholder": "किसी भी आहार प्रतिबंध या सलाह...",
      "activityLabel": "गतिविधि प्रतिबंध",
      "activityPlaceholder": "शारीरिक गतिविधि की सीमाएँ...",
      "warningSignsLabel": "ध्यान देने योग्य चेतावनी संकेत",
      "warningSignsPlaceholder": "ऐसे लक्षण जिन पर रोगी को लौटना या उपचार लेना चाहिए..."
    },
    "nursing": {
      "title": "नर्सिंग कार्य",
      "instructions": "डिस्चार्ज से पहले निम्न चेकलिस्ट पूरी करें। ये कार्य केवल जानकारी के लिए हैं और कोई API कॉल नहीं करते।",
      "tasks": {
        "removeIv": "IV एक्सेस हटाएँ",
        "discontinueMonitoring": "मॉनिटरिंग उपकरण हटाएँ",
        "patientEducation": "रोगी शिक्षा पूर्ण",
        "medsReviewed": "डिस्चार्ज दवाओं की रोगी के साथ समीक्षा पूर्ण",
        "belongingsReturned": "व्यक्तिगत सामान लौटाया गया",
        "transportArranged": "परिवहन की व्यवस्था की गई"
      }
    },
    "signoff": {
      "title": "अटेंडिंग चिकित्सक के हस्ताक्षर",
      "instructions": "नीचे दिए डिस्चार्ज सारांश की समीक्षा करें और अटेंडिंग चिकित्सक के हस्ताक्षर लें।",
      "diagnosisHeading": "डिस्चार्ज निदान",
      "notProvided": "उपलब्ध नहीं",
      "medicationsHeading": "डिस्चार्ज दवाएँ",
      "noMedications": "मिलान के लिए कोई दवा नहीं",
      "signedCompleted": "अटेंडिंग चिकित्सक के हस्ताक्षर पूर्ण।",
      "signAsAttending": "अटेंडिंग चिकित्सक के रूप में हस्ताक्षर करें",
      "requiresAttendingSignoff": "अटेंडिंग चिकित्सक के हस्ताक्षर आवश्यक हैं"
    },
    "review": {
      "title": "डिस्चार्ज की समीक्षा और पुष्टि",
      "summaryHeading": "डिस्चार्ज सारांश",
      "fields": {
        "diagnosis": "निदान:",
        "procedures": "प्रक्रियाएँ:",
        "condition": "स्थिति:",
        "provider": "चिकित्सक:",
        "date": "दिनांक:",
        "notes": "नोट्स:",
        "general": "सामान्य:",
        "diet": "आहार:",
        "activity": "गतिविधि:",
        "warningSigns": "चेतावनी संकेत:"
      },
      "medicationsHeading": "दवा मिलान",
      "noMedications": "मिलान के लिए कोई दवा नहीं",
      "followupHeading": "फ़ॉलो-अप",
      "instructionsHeading": "रोगी के लिए निर्देश",
      "noInstructions": "कोई निर्देश नहीं दिया गया",
      "pendingOrdersWarning": "लंबित आदेश या अहस्ताक्षरित नोट्स हो सकते हैं। डिस्चार्ज पूरा करने से पहले सत्यापित करें।",
      "diagnosisRequired": "डिस्चार्ज पूरा करने से पहले डिस्चार्ज निदान आवश्यक है।",
      "empty": "--"
    },
    "nav": {
      "previous": "पिछला",
      "next": "अगला",
      "complete": "डिस्चार्ज पूरा करें"
    },
    "toast": {
      "success": "रोगी सफलतापूर्वक डिस्चार्ज किया गया",
      "error": "डिस्चार्ज पूरा करने में विफल"
    }
  },
  "components": {
    "transferDialog": {
      "title": "मुलाकात स्थानांतरित करें",
      "description": "रोगी को सुविधा के भीतर किसी अन्य स्थान पर ले जाएं।",
      "targetLocationLabel": "लक्ष्य स्थान",
      "loadingLocations": "स्थान लोड हो रहे हैं…",
      "selectLocation": "एक स्थान चुनें",
      "emptyState": "इस सुविधा में कोई अन्य सक्रिय स्थान नहीं है।",
      "reasonLabel": "कारण",
      "reasonPlaceholder": "उदा. आइसोलेशन आवश्यक, ICU स्टेप-डाउन, उच्च निगरानी बेड",
      "actions": {
        "transfer": "स्थानांतरित करें"
      },
      "toasts": {
        "success": "मुलाकात स्थानांतरित हो गई",
        "error": "मुलाकात स्थानांतरित करने में विफल"
      }
    },
    "assignAttendingDialog": {
      "title": "उपस्थित चिकित्सक की नियुक्ति",
      "description": "इस एनकाउंटर के लिए जिम्मेदार उपस्थित चिकित्सक सेट करें।",
      "providerLabel": "उपस्थित चिकित्सक",
      "loadingProviders": "चिकित्सक लोड हो रहे हैं…",
      "selectProvider": "चिकित्सक चुनें",
      "emptyState": "इस सुविधा में कोई सक्रिय चिकित्सक नहीं है।",
      "actions": {
        "assign": "नियुक्त करें"
      },
      "toasts": {
        "success": "उपस्थित चिकित्सक नियुक्त किया गया",
        "error": "उपस्थित चिकित्सक नियुक्त नहीं किया जा सका"
      }
    },
    "bedBoard": {
      "bedStatus": {
        "available": "उपलब्ध",
        "occupied": "अधिग्रहित",
        "reserved": "आरक्षित",
        "cleaning": "सफाई हो रही है",
        "closed": "बंद",
        "isolated": "पृथक्कृत",
        "contaminated": "संदूषित"
      },
      "acuityLegendLabel": "ESI तीव्रता:",
      "empty": "कोई इकाई कॉन्फ़िगर नहीं की गई",
      "summary": {
        "available_one": "{{count}} उपलब्ध",
        "available_other": "{{count}} उपलब्ध",
        "occupied_one": "{{count}} अधिग्रहित",
        "occupied_other": "{{count}} अधिग्रहित",
        "reserved_one": "{{count}} आरक्षित",
        "reserved_other": "{{count}} आरक्षित",
        "cleaning_one": "{{count}} सफाई हो रही है",
        "cleaning_other": "{{count}} सफाई हो रही है",
        "closed_one": "{{count}} बंद",
        "closed_other": "{{count}} बंद",
        "isolated_one": "{{count}} पृथक्कृत",
        "isolated_other": "{{count}} पृथक्कृत",
        "contaminated_one": "{{count}} संदूषित",
        "contaminated_other": "{{count}} संदूषित"
      }
    },
    "protocolPanel": {
      "title": "प्रोटोकॉल नामांकन",
      "enroll": "नामांकन करें",
      "availableProtocols": "उपलब्ध प्रोटोकॉल",
      "loadingProtocols": "प्रोटोकॉल लोड हो रहे हैं...",
      "noProtocols": "कोई प्रोटोकॉल उपलब्ध नहीं",
      "stepBadge": "चरण {{current}}/{{total}}",
      "loadingEnrollments": "नामांकन लोड हो रहे हैं...",
      "noEnrollments": "कोई सक्रिय प्रोटोकॉल नामांकन नहीं",
      "completeStep": "चरण पूरा करें",
      "toasts": {
        "enrollSuccess": "प्रोटोकॉल में नामांकित",
        "enrollError": "प्रोटोकॉल में नामांकन विफल",
        "advanceSuccess": "चरण पूरा हुआ",
        "advanceError": "चरण आगे बढ़ाने में विफल"
      }
    }
  }
}
